// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-add-form {
    display: flex;
    gap: 12px;
    align-items: center;
    max-width: 480px;
}

.inline-edit-form {
    display: flex;
    gap: 8px;
    align-items: center;
}

.inline-edit-input {
    padding: 4px 8px !important;
    font-size: 13px !important;
    width: 200px;
}

.action-link {
    background: none;
    border: none;
    color: #2563eb;
    cursor: pointer;
    font-size: 13px;
    padding: 0 8px 0 0;
    text-decoration: underline;
}

.action-link-danger {
    color: #dc2626;
}

.action-btn-save {
    padding: 4px 10px;
    background-color: #111827;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.action-btn-cancel {
    padding: 4px 10px;
    background-color: #e5e7eb;
    color: #111827;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.form-error-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    padding: 10px 14px;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    color: #dc2626;
    font-size: 13px;
}

.form-error-close {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    font-size: 14px;
    padding: 0 0 0 12px;
    line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BlogCategories/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".category-add-form {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    max-width: 480px;\n}\n\n.inline-edit-form {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.inline-edit-input {\n    padding: 4px 8px !important;\n    font-size: 13px !important;\n    width: 200px;\n}\n\n.action-link {\n    background: none;\n    border: none;\n    color: #2563eb;\n    cursor: pointer;\n    font-size: 13px;\n    padding: 0 8px 0 0;\n    text-decoration: underline;\n}\n\n.action-link-danger {\n    color: #dc2626;\n}\n\n.action-btn-save {\n    padding: 4px 10px;\n    background-color: #111827;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.action-btn-cancel {\n    padding: 4px 10px;\n    background-color: #e5e7eb;\n    color: #111827;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.form-error-banner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 12px;\n    padding: 10px 14px;\n    background-color: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 6px;\n    color: #dc2626;\n    font-size: 13px;\n}\n\n.form-error-close {\n    background: none;\n    border: none;\n    color: #dc2626;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0 0 0 12px;\n    line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
